<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
   <div class="save-panel">
          <button class="btn btn-sm btn-warning btn-icon" @click="updateItem">
               <span class="ti-save"></span>Сохранить
          </button>
    </div>



    <hr/>

    <h6>Список модификаций:</h6>

    <ul>
        <li v-for="modification in item.options" :key="modification.id">
           <span @click="setModification(modification)" class="link"> {{modification.display_name}} -    {{modification.price}}  сум </span>
        </li>
    </ul>
  </div>
</template>

<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "warehouse/groups",
    cardSetLink: "warehouse/groups",
    item: null,
    fields: [
  
      {
        col:' col-12 col-md-12',
        key: "categories",
        label: "Категории (тут оставим?)",
        type: "selects",
        selectKey: "title",
        modal: "category",
      },
      {
        col:' col-12 col-md-6',
        key: "brand",
        label: "Бренд",
        type: "select",
        selectKey: "name",
        modal: "brand",
      },
      {
        col:' col-12 col-md-6',
        key: "name",
        label: "Класс",
        type: "select",
        selectKey: "title",
        modal: "name",
      },
      {
       col:' col-12 col-md-4',
        key: "vendor_code",
        label: "Артикул (группа)",
        type: "field",
        textType: "text",
      },

          {
                   col:' col-12 col-md-8',
          label: "Название",
          key: "title",
          type: "field",
          textType: "text", 
          isMultiLang:true
      },
    ],
  }),

  props: ["id"],
  async created() {
      // this.cardLink =  `warehouse/options/${this.id}/products`;
      // this.cardSetLink = `warehouse/options/${this.id}/products`;
      this.item = await this.cardContent(this.cardLink, this.id);
},
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(this.cardSetLink, this.item, this.fields);
    },
    setModification(item = {}){
      let query = Object.assign({}, this.$route.query);
      if (query["item_option"] ==  item['id']) {
        return false;
      }
      if (query["item_option"]) {
        delete query["item_option"];
      }
      query["item_option"] = item['id'];
        setTimeout(() => {
        this.$router.replace({ query: query });
      }, 20);
    }
  },
};
</script>
<style>
</style>
